import { createSlice } from "@reduxjs/toolkit";

const toastState = {
  isToastActive: false as boolean,
  toastMessage: "" as string,
  toastType: "success" as any,
};

export const toastSlice = createSlice({
  name: "toaster",
  initialState: toastState,
  reducers: {
    setToastData: (state, action) => {
      (state.isToastActive = action.payload.isToastActive),
        (state.toastMessage = action.payload.toastMessage),
        (state.toastType = action.payload.toastType);
    },
    resetToastData: () => toastState,
  },
});

export const { setToastData, resetToastData } = toastSlice.actions;

export default toastSlice.reducer;
